import { render, staticRenderFns } from "./NotificationsAuth.vue?vue&type=template&id=2328a310&"
import script from "./NotificationsAuth.vue?vue&type=script&lang=js&"
export * from "./NotificationsAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports